import React, {useEffect, useMemo} from 'react';
import MediaQuery from 'react-responsive';
import {Route} from 'react-router-dom';
import {Transition, TransitionGroup} from 'react-transition-group';
import {handleEnterAnimation, handleExitAnimation} from '../../animations/timelines/modal-transitions';
import ReviewFormSwitcher from '../../components/ReviewFormSwitcher';
import ENDPOINT from '../../constants/endpoints';
import LinkBuilder from '../../helpers/link-builder';
import {useGridFilters} from '../../hooks/useGridFilters';
import PageLayout from '../../layouts/PageLayout';
import FiltersAccordion from '../../scenes/FiltersAccordion';
import FiltersWidget from '../../scenes/FiltersAccordion/components/FiltersWidget';
import Sidebar from '../../scenes/Sidebar';
import './styles.css';

const AddReview = props => {
  const {
    match: {
      params: { formType },
    },
    history,
    user,
  } = props;

  const queryParams = useMemo(() => {
    const result = {};
    const params = new URLSearchParams(history.location.search);
    if (params.has('position')) {
      result.position = params.get('position');
    } else if (params.has('firm')) {
      result.firm = params.get('firm');
    }
    return result;
  }, [history.location.search]);

  const filters = useGridFilters(ENDPOINT.FILTERS.REVIEWS);

  useEffect(() => {
    filters.actions.fetch();
  }, []);

  const filtersAccordion = useMemo(
    () =>
      filters.data ? (
        <FiltersAccordion
          title={'Search Review'}
          subTitle={
            'Use the search filters below to narrow your review search.'
          }
          filters={filters.data}
          onChange={filters.actions.change}
          onGroupSelectAll={filters.actions.groupSelect}
          onGroupClearAll={filters.actions.groupClear}
          onClearAll={filters.actions.clear}
          onSearch={filters.actions.search}
          onPushValue={filters.actions.push}
          render={renderProps => <FiltersWidget {...renderProps} />}
        />
      ) : null,
    [filters.data]
  );

  const handleChangeForm = type => {
    history.push(LinkBuilder.getAddReviewLink(type));
  };

  return (
    <PageLayout
      pageClass="reviews-page"
      pageTitle="Add Review"
      mainContent={
        <>
          <Route
            render={({ location }) => {
              return (
                <TransitionGroup component={null}>
                  <Transition
                    key={location.pathname}
                    timeout={500}
                    mountOnEnter={true}
                    unmountOnExit={true}
                    onEnter={node => handleEnterAnimation(node)}
                    onExit={node => handleExitAnimation(node)}
                  >
                    <ReviewFormSwitcher
                      user={user}
                      firm={queryParams.firm}
                      position={queryParams.position}
                      formType={formType}
                      onChange={handleChangeForm}
                    />
                  </Transition>
                </TransitionGroup>
              );
            }}
          />
        </>
      }
      sidebarContent={
        <Sidebar>
          <MediaQuery query="(min-width: 768px)">{filtersAccordion}</MediaQuery>
        </Sidebar>
      }
    />
  );
};

export default AddReview;
